import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-2047">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-2048">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-2049">
          Wire EDM Traditional
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-2050">
          CHMER EDM Wire Cutting Solutions
        </p>
      </div>
    </div>;
}